import { omit } from "lodash"
import { useCallback, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { removeUndefined } from "@tfg/types/schemas/utils"

import { FindCertificatesByOrganizationIdQueryParams } from "~/gen/api"

export const useSearchParamsFilters = (): [
  FindCertificatesByOrganizationIdQueryParams,
  React.Dispatch<
    React.SetStateAction<FindCertificatesByOrganizationIdQueryParams>
  >,
  (key: keyof FindCertificatesByOrganizationIdQueryParams) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [filters, setFilters] =
    useState<FindCertificatesByOrganizationIdQueryParams>(
      Object.fromEntries(searchParams.entries())
    )

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      ...removeUndefined(filters),
    }))
  }, [filters, setSearchParams])

  const unsetFilter = useCallback(
    (key: keyof FindCertificatesByOrganizationIdQueryParams) => {
      setFilters((prev) => omit(prev, key))
      setSearchParams((prev) => omit(prev, key))
    },
    [setFilters, setSearchParams]
  )

  return [filters, setFilters, unsetFilter]
}
